import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { UserAccessType } from '../enums/object-type.enum';
import { UserRole } from '../enums/user-role.enum';
import { User } from '../models/user.model';
import { StorageService } from './storage.service';
import { Router } from '@angular/router';
import {SharedMenuService} from 'src/app/core/services/shared-menu.service';
import {EncryptionService} from 'src/app/core/services/aes.service';
import {CryptoService} from 'src/app/core/services/crypto.service';
import {ThemeService} from 'src/app/core/services/theme.service';




@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient,
              private storageService: StorageService,
              private router:Router,
              private sharedMenuService:SharedMenuService,
              private aes:EncryptionService,
              private crypto:CryptoService,
              private themeService:ThemeService

  ) { }
  private apiUrl = environment.api;

  login(username: string, password: string): Observable<any> {
    return this.http.post(this.apiUrl + "/auth/login", { username, password }).pipe(
      tap((response: any) => {

        if (response && response.accessToken) {
          this.sharedMenuService.clearData();
          const obj = {
            name: username
          }

          sessionStorage.setItem("user-info", JSON.stringify(obj));

          if(!environment.production){
            localStorage.setItem('TOKEN', response.accessToken);
            localStorage.setItem('REFRESH_TOKEN', response.refreshToken);
          }

          localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(response.accessToken));
          localStorage.setItem(this.crypto.encrypt('REFRESH_TOKEN'), this.crypto.encrypt(response.refreshToken));

        }
      })
    );
  }


  loginWithGoogle(token: string): Observable<any> {
    return this.http.post(this.apiUrl + "/auth/loginRss", { token }).pipe(
      tap((response: any) => {
        if (response && response.accessToken) {
          this.sharedMenuService.clearData();
          const decodedToken = this.decodeToken(response.accessToken);
          const obj = {
            name: decodedToken.email
          }
          sessionStorage.setItem("user-info", JSON.stringify(obj));
          if(!environment.production){
            localStorage.setItem('TOKEN', response.accessToken);
            localStorage.setItem('REFRESH_TOKEN', response.refreshToken);
          }

          localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(response.accessToken));
          localStorage.setItem(this.crypto.encrypt('REFRESH_TOKEN'), this.crypto.encrypt(response.refreshToken));

        }
      })
    );
  }

  signUpWithGoogle(token: string): Observable<any> {
    return this.http.post(this.apiUrl + "/auth/sign-up-google", { token }).pipe(
      tap((response: any) => {
        if (response && response.accessToken) {
          this.sharedMenuService.clearData();
          const decodedToken = this.decodeToken(response.accessToken);
          const obj = {
            name: decodedToken.email
          }
          sessionStorage.setItem("user-info", JSON.stringify(obj));
          if(!environment.production){
            localStorage.setItem('TOKEN', response.accessToken);
            localStorage.setItem('REFRESH_TOKEN', response.refreshToken);
          }
          localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(response.accessToken));
          localStorage.setItem(this.crypto.encrypt('REFRESH_TOKEN'), this.crypto.encrypt(response.refreshToken));

        }
      })
    );
  }

  signUp(data: any): Observable<any> {
    return this.http.post(this.apiUrl + "/auth/sign-up", data).pipe(
      tap((response: any) => {
        if (response && response.accessToken) {
          this.sharedMenuService.clearData();
          const decodedToken = this.decodeToken(response.accessToken);
          const obj = {
            name: decodedToken.email
          }
          sessionStorage.setItem("user-info", JSON.stringify(obj));
          if(!environment.production){
            localStorage.setItem('TOKEN', response.accessToken);
            localStorage.setItem('REFRESH_TOKEN', response.refreshToken);
          }
          localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(response.accessToken));
          localStorage.setItem(this.crypto.encrypt('REFRESH_TOKEN'), this.crypto.encrypt(response.refreshToken));

        }
      })
    );
  }

   decodeToken(token: string): any {
    try {
      const base64Url = token.split('.')[1]; // Extrae el payload (segunda parte del JWT)
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const decodedPayload = JSON.parse(atob(base64));
      return decodedPayload;
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

  public isAuthenticated(): boolean {
    const userInfo = this.storageService.getUser();
    if (!userInfo) {
      return false;
    }
    return true;
  }
  public get currentUser(): any {
    if (this.isAuthenticated()) {
      return <User>this.storageService.getUser();
    } else {
      this.logout();
      return null;
    }
  }
  haveAccess(accessList?: { accessType: UserAccessType, role?: UserRole }[]): boolean {
    if (!accessList)
      return true;
    const userAccessList = this.currentUser.accessList;
    for (let i = 0; i < accessList.length; i++) {
      const access = accessList[i];
      if (userAccessList?.findIndex((r: any) => r.accessType === access.accessType && (!access.role || r.role === access.role)) >= 0)
        return true;
    }
    return false;
  }
  extendSession() {
    const userInfo = this.storageService.getUser();
    if (userInfo) {
      const d = new Date();
      d.setMinutes(d.getMinutes() + environment.sessionTimeoutToMinute);
      userInfo.expireAt = d;
      this.storageService.setUser(userInfo);
    }
  }
  getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null;
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }
  getTokenRefresh(): any {
    if (typeof localStorage === 'undefined') return null;
    const encryptedKey = this.crypto.encrypt('REFRESH_TOKEN');
    const encryptedToken = localStorage.getItem(encryptedKey);
    if (encryptedToken) {
      return encryptedToken
    }
    return null;

  }
  getToken(): string | null {
    if (typeof localStorage === 'undefined') return null;
    const encryptedKey = this.crypto.encrypt('TOKEN');
    const encryptedToken = localStorage.getItem(encryptedKey);
    if (encryptedToken) {
      return this.crypto.decrypt(encryptedToken)
    }
    return null;

  }
  setToken(token: string): void {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(token));
  }
  isUserAuthenticated(): boolean {
    const token = this.getToken();
    return token !== null; // Devuelve true si existe un token, de lo contrario false
  }
  refreshToken(): Observable<any> {
    if (typeof localStorage === 'undefined') {
      return of(null);
    }
    const encryptedKey = this.crypto.encrypt('REFRESH_TOKEN');
    const encryptedToken = localStorage.getItem(encryptedKey);

    if(!encryptedToken)
      return new Observable(observer => {
        observer.next(null);
        observer.complete();
      }
      )
    const refreshToken = this.crypto.decrypt(encryptedToken);

    return this.http.post(this.apiUrl + '/auth/refresh', { refreshToken }).pipe(
      switchMap((response: any) => {
        if (response && response.accessToken) {
          localStorage.setItem(this.crypto.encrypt('TOKEN'), this.crypto.encrypt(response.accessToken));
          if (response.refreshToken) {
            localStorage.setItem(this.crypto.encrypt('REFRESH_TOKEN'), this.crypto.encrypt(response.refreshToken));
          }
          if(!environment.production){
            localStorage.setItem('TOKEN', response.accessToken);
            localStorage.setItem('REFRESH_TOKEN', response.refreshToken);
          }

        }
        // Return an observable to indicate token has been refreshed and stored
        return new Observable(observer => {
          observer.next(response);
          observer.complete();
        });
      })
    );
  }
  logout(): void {

    this.router.navigate(['/login']);

    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem("user-info");
    }
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('account-setting');
      localStorage.removeItem('lastVisitedRoute');
      localStorage.removeItem('alias');
      localStorage.clear();
    }
    this.themeService.loadStoredTheme();
    //this.getCookie()
    //this.isAuthenticatedSubject.next(false);
  }
  requestResetPassword(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/request-reset`,data);
  }
  resetPassword(data: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/reset-pass`, data);
  }
  validateTwoFactor(email: string, twoFactorToken: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/auth/validate-2fa`, { email, twoFactorToken });
  }
  getServerTime(): Observable<any> {
    return this.http.get(this.apiUrl + '/auth/time/param');
  }
}
